import {likeSourceType} from '@/Constant';
import {DOC_TYPE, DOC_TYPE_KEY, IDocType} from '@/constants/document/doc';
import {KU_TYPE} from '@/constants/document/doc';
import {
    DocumentSvg, KnowledgeBookSvg, SheetSvg,
    SidebarSheetSvg, SidebarTeamSvg, SidebarPageSvg,
    SidebarPPTSvg, PPTSvg, SidebarDataSheetSvg, DataSheetSvg,
    HomeLikeDuLiveBroadcastSvg, HomeLikeCompetingGoodsSvg,
    HomeLikeDuNewsSvg, HomeLikeForumSvg,
    HomeLikeInstantUnderStandSvg,
    HomeLikeOtherLinksSvg,
    HomeLikeKnowledgeSvg,
} from '@/icons';

/**
 * 根据页面类型，获取列表展示图标
 * @param type 页面类型
 * @returns 列表展示图标
 */
export const getDocFillSvgByType = (type?: number) => {
    if (type === DOC_TYPE.DIRECTORY) {
        return KnowledgeBookSvg;
    }
    if (type === DOC_TYPE.SHEET) {
        return SheetSvg;
    }
    if (type === DOC_TYPE.PPT) {
        return PPTSvg;
    }
    if (type === DOC_TYPE.DATASHEET) {
        return DataSheetSvg;
    }
    return DocumentSvg;
};

/**
 * 根据页面类型，获取点赞列表展示图标
 * @param type 页面类型
 * @returns 列表展示图标
 */
export const getLikeDocSvgBySourceType = (type?: string) => {
    if (type === likeSourceType.knowledgeKu) {
        return {
            sourceSvg: HomeLikeKnowledgeSvg,
            sourceName: '知识库',
        };
    }
    if (type === likeSourceType.productForum) {
        return {
            sourceSvg: HomeLikeForumSvg,
            sourceName: '产品论坛',
        };
    }
    if (type === likeSourceType.duLiveBroadcast) {
        return {
            sourceSvg: HomeLikeDuLiveBroadcastSvg,
            sourceName: '度学堂',
        };
    }
    if (type === likeSourceType.competingGoods) {
        return {
            sourceSvg: HomeLikeCompetingGoodsSvg,
            sourceName: '竞品观察室',
        };
    }
    if (type === likeSourceType.duNews) {
        return {
            sourceSvg: HomeLikeDuNewsSvg,
            sourceName: '度新闻',
        };
    }
    if (type === likeSourceType.instantUnderStand) {
        return {
            sourceSvg: HomeLikeInstantUnderStandSvg,
            sourceName: '秒懂百科',
        };
    }
    return {
        sourceSvg: HomeLikeOtherLinksSvg,
        sourceName: type,
    };
};

/**
 * 根据页面类型，判断是否属于知识库中文档类型（文档、知识本、表格、演示文稿、数据表）
 * @param type 页面类型
 * @returns {boolean}
 */
export const checkIsDocPageByType = (type?: number) => {
    return Object.values(DOC_TYPE).includes(type as IDocType);
};

/**
 * 根据页面类型，获取目录树图标
 * @param type 页面类型
 * @returns 目录树图标
 */
export const getDocSideSvgByType = (type: number) => {
    if (type === DOC_TYPE.DIRECTORY) {
        return SidebarTeamSvg;
    }
    if (type === DOC_TYPE.SHEET) {
        return SidebarSheetSvg;
    }
    if (type === DOC_TYPE.PPT) {
        return SidebarPPTSvg;
    }
    if (type === DOC_TYPE.DATASHEET) {
        return SidebarDataSheetSvg;
    }
    return SidebarPageSvg;
};

/**
 * 根据页面类型，获取页面对应 key 值（目前仅链接识别使用）
 * @param type 页面类型
 * @returns 页面对应 key 值
 */
export const getDocKeyByType = (type: number) => {
    // 知识本编辑器暂未接
    // if (type === DOC_TYPE.DIRECTORY) {
    //     return 'book';
    // }
    if (type === DOC_TYPE.DOCUMENT) {
        return DOC_TYPE_KEY.DOCUMENT;
    }
    if (type === DOC_TYPE.SHEET) {
        return DOC_TYPE_KEY.SHEET;
    }
    if (type === DOC_TYPE.PPT) {
        return DOC_TYPE_KEY.PPT;
    }
    if (type === DOC_TYPE.DATASHEET) {
        return DOC_TYPE_KEY.DATASHEET;
    }
    return '';
};

export const getDepartmentDocFillSvgByType = (type: number) => {
    if (type === KU_TYPE.Book) {
        return KnowledgeBookSvg;
    }
    if (type === KU_TYPE.Sheet) {
        return SheetSvg;
    }
    if (type === KU_TYPE.PPT) {
        return PPTSvg;
    }
    if (type === KU_TYPE.DataSheet) {
        return DataSheetSvg;
    }
    return DocumentSvg;
};
